import React from "react";
import AddTravellerDetailsComp from "../AddTravellerDetailsComp/AddTravellerDetailsComp";
import DisclaimerComp from "../DisclaimerComp/DisclaimerComp";
import HeaderTitleComp from "../HeaderTitleComp/HeaderTitleComp";
import ItineraryInfoComp from "../ItineraryInfoComp/ItineraryInfoComp";
import LandingButtonComp from "../LandingButtonComp/LandingButtonComp";
import PlanPriceInfoComp from "../PlanPriceInfoComp/PlanPriceInfoComp";
import PriceBreakup from "../PriceBreakup/PriceBreakup";
import PrimaryContactComp from "../PrimaryContactComp/PrimaryContactComp";
import TncComp from "../TncComp/TncComp";
import FilterPlans from "./FilterPlans/FilterPlans";
import PersuasionComponent from "./PersuasionComponent/PersuasionComponent";
import PlanCardsList from "./PlanCardsList/PlanCardsList";
import ShowNetPriceCard from "./ShowNetPriceCard/ShowNetPriceCard";

/**
 * MyPartner-specific component mapper to avoid circular dependencies
 * This is a duplicate of the main ComponentMapper but with direct imports
 * to break the circular dependency chain
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MYPARTNER_COMPONENT_MAPPER: Record<
  string,
  Record<string, React.ComponentType<any>>
> = {
  top: {
    HEADER_TITLE: HeaderTitleComp,
  },
  left: {
    COMPONENT_MYPARTNER_LISTING_PAGE_FILTER_PLANS: FilterPlans,
    COMPONENT_MYPARTNER_TRAVELLER_ATTRIBUTE_ITINERARY_INFO: ItineraryInfoComp,
    COMPONENT_MYPARTNER_TRAVELLER_ATTRIBUTE_PLAN_INFO: PlanPriceInfoComp,
    COMPONENT_MYPARTNER_BUYNOW: LandingButtonComp,
    COMPONENT_MYPARTNER_TRAVELLER_ATTRIBUTE_DISCLAIMER: DisclaimerComp,
    COMPONENT_MYPARTNER_TRAVELLER_ATTRIBUTE_TNC: TncComp,
    PRIMARY_CONTACT: PrimaryContactComp,
    COMPONENT_TRAVELLER_ATTRIBUTE_PAGE_TRAVELLER_DETAIL:
      AddTravellerDetailsComp,
  },
  right: {
    INSURANCE_CARDS: PlanCardsList,
    PERSUASION: PersuasionComponent,
    COMPONENT_MYPARTNER_LISTING_PAGE_ITINERARY_INFO: ItineraryInfoComp,
    PRICE_BREAKUP: PriceBreakup,
    COMPONENT_MYPARTNER_NET_PRICE: ShowNetPriceCard,
  },
};
